import React ,{ Component } from "react";
import { withRouter } from "react-router-dom";
import Labs from "./Labs";
import Exams from './exams'

class LeftSideBar extends Component {
  constructor(props){
    super(props);

    this.state = {
      hasExams: false,
      isFilterScreenOpen: false
    }
  }

  componentDidMount(){
    window.addEventListener("draw-exams", this.checkHasExams.bind(this));
  }

  componentWillUnmount(){
    window.removeEventListener("draw-exams", this.checkHasExams.bind(this))
  }

  checkHasExams(e){
    if(e.detail === null){
      this.setState({hasExams: false});
    }else{
      this.setState({hasExams: true});
    }
  }

  updateFilterScreenStatus(status){
    this.setState({isFilterScreenOpen: status});
  }

  filterStatus(){
    let statusFiltered = {};
    if(this.props.status){
      Object.keys(this.props.status).forEach(index => {
        if(index !== 'BR'){
          statusFiltered[index] = this.props.status[index];
        }
      })
    }
    return statusFiltered;
  }

  render(){
    this.filterStatus()
    return (
      <>
        <div className="block-container">
          <Exams 
            status={this.props.status && this.props.status['BR']}
            exams={this.props.exams}
            currentProductionUnit={this.props.currentProductionUnit}
            updateFilterScreenStatus = {this.updateFilterScreenStatus.bind(this)}
          />
        </div>
        {!this.state.hasExams && !this.state.isFilterScreenOpen ?
        (<div className="block-container row-3" style={{marginTop: '10px'}}>
          <Labs unitsStatus={this.filterStatus()}/>
        </div>): null}
  
      </>
    )
  }
}

export default withRouter(LeftSideBar)